import { useQueryParams } from './use-query-params';

type ModalType =
  | 'createTag'
  | 'createBranch'
  | 'editBranch'
  | 'archiveBranch'
  | 'createEmployee'
  | 'delete'
  | 'qrEmployee'
  | 'viewDynamicQr'
  | 'viewStaticQr'
  | 'createDish'
  | 'createMenu'
  | 'dishCategory'
  | 'dishSection'
  | 'taskInfo'
  | 'promoPreview'
  | 'printQr'
  | 'deleteNode'
  | 'companySensitive'
  | 'imageEditor'
  | 'updatePromo'
  | 'createTask'
  | 'schedulerList'
  | 'unlinkEmployee'
  | 'jobTitlesModal'
  | 'shiftsSchedule'
  | 'restore'
  | 'updateStatementStatus'
  | 'editCheckInCheckOut'
  | 'createAdmin'
  | 'checkinHistory'
  | 'createSchedule'
  | 'copyDish'
  | 'saveUploadedMenu'
  | 'deleteEmployee'
  | 'iikoSync'
  | 'copyMenu'
  | 'scheduleNotifications'
  | 'createFormElement'
  | 'taskForm'
  | 'taskCallback'
  | 'createRole'
  | 'unattachRole'
  | 'nestedCheckins'
  | 'menuSettings'
  | 'createExternalReview'
  | 'editExternalReview'
  | 'deleteExternalReview';

export const useModalParams = (modalId: ModalType) => {
  const { getQueryParams, addQueryParams } = useQueryParams();

  const updated = getQueryParams();

  const handleOpenModal = (externalData?: Record<string, string | number>) => {
    addQueryParams({ modalId, ...externalData, ...updated });
  };

  const handleCloseModal = (externalData?: string[]) => {
    ['modalId', ...(externalData || [])].forEach((key) => (updated[key] = ''));
    addQueryParams(updated);
  };

  const isOpen = updated.modalId === modalId;

  return { handleOpenModal, handleCloseModal, isOpen };
};
